import { render, staticRenderFns } from "./navigationList.vue?vue&type=template&id=1056db4b&"
import script from "./navigationList.vue?vue&type=script&lang=js&"
export * from "./navigationList.vue?vue&type=script&lang=js&"
import style0 from "./navigationList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports